// Info Button Component
// Reusable component to display contextual help information

import React from "react";
import { Button, Tooltip } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "./CSS/InfoButton.css";

const InfoButton = ({ content, infoKey, category }) => {
  const { t } = useTranslation();

  // Deux modes d'usage :
  //   - `content` : texte déjà résolu (ex. content={t("SLA_SECONDS_INFO")}) — prioritaire.
  //   - `infoKey` + `category` : clé INFO.<category>.<infoKey> résolue ici (usage historique).
  // Avant, seul le 2e mode existait : les appels passant `content` (form profil analytics)
  // n'affichaient donc RIEN (infoText vide → return null).
  let infoText = content;
  if (!infoText && category && infoKey) {
    infoText = t(`INFO.${category}.${infoKey}`, { defaultValue: "" });
  }

  if (!infoText) return null;

  return (
    <Tooltip
      content={infoText}
      relationship="description"
      className="info-tooltip"
    >
      <Button
        icon={<InfoRegular className="info-icon" />}
        appearance="transparent"
        iconOnly
        size="small"

      />



    </Tooltip>
  );
};

InfoButton.propTypes = {
  content: PropTypes.node,
  infoKey: PropTypes.string,
  category: PropTypes.string
};

export default InfoButton;
